import axios from 'axios';
import Cookies from 'js-cookie';
import { logOut } from '../../redux/authentication/actionCreator';
import reduxStore from '../../redux/store';
import DOMAIN_API_MAP from './domainApiMap';

const qs = require('qs');

// export const API_ENDPOINT =
//   process.env.NODE_ENV === 'development'
//     ? process.env.REACT_APP_API_ENDPOINT_LOCAL
//     : process.env.REACT_APP_API_ENDPOINT_PROD;

const hostname = window.location.hostname;

console.log('Hostname:', hostname);
// Slash ekleme helper
const ensureSlash = url => (url.endsWith('/') ? url : url + '/');

export const API_ENDPOINT = (() => {
  // 1) Development ortamÄ± â†’ LOCAL API
  if (process.env.NODE_ENV === 'development') {
    return ensureSlash(process.env.REACT_APP_API_ENDPOINT_LOCAL || '');
  }

  // 2) Prod â†’ Domain eÅŸleÅŸmesini kontrol et
  if (DOMAIN_API_MAP[hostname]) {
    return ensureSlash(DOMAIN_API_MAP[hostname]);
  }

  // 3) Prod â†’ AÃ§Ä±kÃ§a env'de tanÄ±mlÄ± prod endpoint varsa onu kullan
  if (process.env.REACT_APP_API_ENDPOINT_PROD) {
    return ensureSlash(process.env.REACT_APP_API_ENDPOINT_PROD);
  }

  // 4) Fallback â†’ origin/api/ (aynÄ± domain API senaryosu)
  return ensureSlash(`${window.location.origin}/api/`);
})();

const authHeader = () => ({
  Authorization: `Bearer ${Cookies.get('access_token')}`,
});

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    Authorization: `Bearer ${Cookies.get('access_token')}`,
    'Content-Type': 'application/json',
  },
});

// Sadece bu endpoint(ler)e giden requestleri logla
const REQUEST_LOG_ENDPOINT_MATCHERS = ['/ihracat/booking/liste/guncelle'];

const ORDER_REQUEST_LOG_KEY = 'ORDER_REQUEST_LOGS';
const ORDER_REQUEST_LOG_LIMIT = 200;
const ORDER_REQUEST_LOG_ERRORS_KEY = 'ORDER_REQUEST_LOG_ERRORS';

const readOrderRequestLogs = () => {
  try {
    const raw = localStorage.getItem(ORDER_REQUEST_LOG_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

const writeOrderRequestLogs = logs => {
  const bounded =
    logs.length > ORDER_REQUEST_LOG_LIMIT
      ? logs.slice(logs.length - ORDER_REQUEST_LOG_LIMIT)
      : logs;
  localStorage.setItem(ORDER_REQUEST_LOG_KEY, JSON.stringify(bounded));
};

const appendOrderRequestLogError = (source, error) => {
  try {
    const raw = localStorage.getItem(ORDER_REQUEST_LOG_ERRORS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    const current = Array.isArray(parsed) ? parsed : [];
    const errorItem = {
      source,
      message: error?.message || String(error),
      time: new Date().toISOString(),
      page: window.location.href,
    };
    const next = [...current, errorItem];
    const bounded =
      next.length > ORDER_REQUEST_LOG_LIMIT
        ? next.slice(next.length - ORDER_REQUEST_LOG_LIMIT)
        : next;
    localStorage.setItem(ORDER_REQUEST_LOG_ERRORS_KEY, JSON.stringify(bounded));
  } catch (_e) {
    // noop
  }
};

const shouldLogRequestByUrl = url => {
  const requestUrl = (url || '').toLowerCase();
  return REQUEST_LOG_ENDPOINT_MATCHERS.some(matcher =>
    requestUrl.includes((matcher || '').toLowerCase())
  );
};

class DataService {
  static get(path = '', params, responseType) {
    /* versionCheck(); */
    return client({
      method: 'GET',
      url: path,
      headers: { ...authHeader() },
      params,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
      responseType: responseType,
    });
  }

  static post(
    path = '',
    data = {},
    params,
    optionalHeader = {},
    timeout,
    responseType
  ) {
    return client({
      method: 'POST',
      url: path,
      data,
      params,
      timeout: timeout,
      responseType: responseType,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }

  static patch(path = '', data = {}, params) {
    return client({
      method: 'PATCH',
      url: path,
      data: JSON.stringify(data),
      params,
      headers: { ...authHeader() },
    });
  }

  static put(path = '', data = {}, params) {
    return client({
      method: 'PUT',
      url: path,
      data: JSON.stringify(data),
      params,
      headers: { ...authHeader() },
    });
  }

  static delete(path = '', params, data = {}) {
    return client({
      method: 'DELETE',
      url: path,
      params,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use(config => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie
  const requestConfig = config;
  const { headers } = config;
  requestConfig.headers = {
    ...headers,
    Authorization: `Bearer ${Cookies.get('access_token')}`,
  };

  // Hedef endpoint request logu
  try {
    const shouldLog = shouldLogRequestByUrl(requestConfig.url);
    if (shouldLog) {
      const requestId = `${Date.now()}-${Math.random()
        .toString(36)
        .slice(2, 10)}`;
      requestConfig.__logRequestId = requestId;

      const logData = {
        requestId,
        url: requestConfig.url,
        method: requestConfig.method,
        params: requestConfig.params,
        data: requestConfig.data,
        headers: requestConfig.headers,
        time: new Date().toISOString(),
        page: window.location.href,
        status: 'pending',
      };

      console.log('API REQUEST LOG =>', logData);
      const currentLogs = readOrderRequestLogs();
      const nextLogs = Array.isArray(currentLogs)
        ? [...currentLogs, logData]
        : [logData];
      writeOrderRequestLogs(nextLogs);
    }
  } catch (e) {
    /* console.warn('Request logging failed:', e); */
    appendOrderRequestLogError('request_interceptor', e);
  }

  return requestConfig;
});

let isLoggingOut = false;

client.interceptors.response.use(
  response => {
    try {
      const shouldLog = shouldLogRequestByUrl(response?.config?.url);
      if (shouldLog) {
        const requestId = response?.config?.__logRequestId;
        const logs = readOrderRequestLogs();
        const index = logs.findIndex(log => log.requestId === requestId);
        if (index >= 0) {
          logs[index] = {
            ...logs[index],
            status: 'success',
            responseStatus: response.status,
            responseStatusText: response.statusText,
            responseTime: new Date().toISOString(),
          };
          writeOrderRequestLogs(logs);
        }
      }
    } catch (e) {
      /* console.warn('Response success logging failed:', e); */
      appendOrderRequestLogError('response_success_interceptor', e);
    }
    return response;
  },
  error => {
    /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
    const { response } = error;
    try {
      const shouldLog = shouldLogRequestByUrl(error?.config?.url);
      if (shouldLog) {
        const requestId = error?.config?.__logRequestId;
        const logs = readOrderRequestLogs();
        const index = logs.findIndex(log => log.requestId === requestId);
        if (index >= 0) {
          logs[index] = {
            ...logs[index],
            status: 'error',
            responseStatus: response?.status || 0,
            responseStatusText:
              response?.statusText || error?.message || 'Network Error',
            responseTime: new Date().toISOString(),
          };
          writeOrderRequestLogs(logs);
        }
      }
    } catch (e) {
      /* console.warn('Response error logging failed:', e); */
      appendOrderRequestLogError('response_error_interceptor', e);
    }
    if (response) {
      if (response.status === 401 && !response.config.url.includes('/logout')) {
        if (isLoggingOut) {
          return Promise.reject({
            status: 401,
            statusText: 'Already logging out',
          });
        }

        isLoggingOut = true;

        reduxStore.dispatch(logOut());
        Cookies.remove('version');
        return { status: 401, statusText: response.statusText };
      } else if (response.status === 400) {
        // Array Buffer KontrolÃ¼ YapÄ±lmakta
        if (!response.data.byteLength)
          return {
            status: 400,
            statusText: response.data.message,
          };
        else {
          const parsedResponse = JSON.parse(
            new TextDecoder().decode(response.data)
          );
          return {
            status: 400,
            statusText: parsedResponse.message,
          };
        }
      } else if (response.status === 403) {
        return { status: 403, statusText: response.data.message };
      } else if (response.status === 404) {
        return { status: 404, statusText: response.data.message };
      } else if (response.status === 500) {
        // Array Buffer KontrolÃ¼ YapÄ±lmakta
        if (!response.data.byteLength)
          return {
            status: 500,
            statusText: response.data.message,
          };
        else {
          const parsedResponse = JSON.parse(
            new TextDecoder().decode(response.data)
          );
          return {
            status: 500,
            statusText: parsedResponse.message,
          };
        }
      } else if (response.status === 409) {
        return { status: 409, statusText: response.data.message };
      }
    } else {
      return { status: 500, statusText: error.message || 'Network Error' };
    }
  }
);
export { DataService };
